/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum OrderTypeEnum {
    ASCENDING = 'ascending',
    DESCENDING = 'descending',
}
